import { AgentConversationMessage } from '../services/agent.service';

/**
 * The batch lines a conversation fetch brought back that the transcript does not already hold.
 *
 * <p>Only the batch kinds: a local reply has no id — it was pushed straight into the array when
 * the response arrived — so filtering by kind is what stops it being appended twice.
 *
 * <p>And only ids the transcript has not seen. The batch tracker fires an `item` event and a
 * `batch` event in the same poll when the last invoice finishes, so two fetches run with the same
 * "after this id" cursor and both come back holding the same lines. Seen on dev (2026-09-30):
 * every ⏸️/✅ line and every summary rendered twice.
 */
export function onlyNewBatchMessages(
  fetched: readonly AgentConversationMessage[],
  transcript: readonly AgentConversationMessage[],
): AgentConversationMessage[] {
  const known = new Set(transcript.map(m => m.id).filter((id): id is number => id !== undefined));
  const out: AgentConversationMessage[] = [];

  for (const m of fetched) {
    if (m.kind !== 'batch_item' && m.kind !== 'batch_summary') continue;
    if (m.id !== undefined && known.has(m.id)) continue;
    if (m.id !== undefined) known.add(m.id);
    out.push(m);
  }

  return out;
}
